import ApiUserLimitsList from './ApiUserLimitsList';
import ApiUserLimitsShow from './ApiUserLimitsShow';

const resource = {
  list: ApiUserLimitsList,
  show: ApiUserLimitsShow,
};

export default resource;
